import { render, staticRenderFns } from "./CounterpartyDetailsHeader.vue?vue&type=template&id=469d1632&"
import script from "./CounterpartyDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./CounterpartyDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports